(ns entities.tax.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.tax.specs :as sp]
    )
  )

(def path [:entities :tax])

(rf/reg-entity
  :tax
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/tax)
                :success [:tax/fetched]
                :error [:tax/fetch-errored]
                :cancellable? true}})
   :patch
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/update-tax {:input data})
                :success [:tax/updated]
                :error [:tax/update-errored]}})

   })

(rf/reg-event-db
  :tax/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :tax])))

(rf/reg-event-db
  :tax/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :tax])))

(rf/reg-event-db
  :tax/updated
  (rf/path path)
  (fn [_ [data]]
    (:update-tax-information data)))

(rf/reg-event-db
  :tax/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (:update-tax-information data)))
